import apis from "../../core/apis.js";

class CorporateTransportationSubmissionsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.corporateTransportationSubmissions).get(options);
  }

  get(id) {
    return this.$resource(apis.corporateTransportationSubmissions + id).get();
  }

  search(search = "") {
    return this.$resource(apis.corporateTransportationSubmissions).get({
      search,
    });
  }

  post(item) {
    return this.$resource(apis.corporateTransportationSubmissions).save(item);
  }

  update(id, item) {
    return this.$resource(apis.corporateTransportationSubmissions + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default CorporateTransportationSubmissionsResource;



// WEBPACK FOOTER //
// ./src/resources/corporateTransportationSubmissions/corporateTransportationSubmissions.resource.js